export interface ApiErrorInput {
  body: any
  status: number
  response: Response
  message?: string
  detail?: string
}

export type GetApiErrorMessage = (error: ApiErrorInput) => string | undefined
export type GetApiFallbackErrorMessage = (error: ApiErrorInput) => string

export default class ApiError extends Error {
  body: any
  status: number
  response: Response
  hasToRetry = false
  isUnknownError = false
  shouldInvalidateForm = true
  children: Record<string, Error> = {}

  constructor(
    error: ApiErrorInput,
    getApiErrorMessage: GetApiErrorMessage = e => e.message ?? 'Unknown error',
    getApiFallbackErrorMessage: GetApiFallbackErrorMessage = e => e.detail ?? '',
  ) {
    const message = getApiErrorMessage(error)
    const fallBackMessage = getApiFallbackErrorMessage(error)
    super(message ?? fallBackMessage)
    this.body = error.body
    this.status = error.status
    this.response = error.response
    this.isUnknownError = message === undefined
    this.children = this.getChildren()
  }

  getChildren(): Record<string, Error> {
    return {}
  }
}
